/**
 * Footballer Quiz (Warmup) — client constants. A daily "guess the mystery footballer" game; each guess is
 * compared across five tiles (NAT · LGE · TEAM · POS · AGE), each green / amber / grey, with a ▲/▼ age
 * arrow. Colors mirror the design (`Footballer Quiz.dc.html`); the server stays the source of truth for the
 * comparison, coins, and streak. The mock's SHIRT tile is dropped (no shirt-number data) — see
 * specs/footballer-quiz/spec.md.
 */

import { WARMUP_COLORS } from './warmup.constants';

export const FOOTBALLER_GAME_KEY = 'FOOTBALLER';

/** Display figures (server authoritative). */
export const FOOTBALLER_MAX_GUESSES = 8;
export const FOOTBALLER_WIN_REWARD_COINS = 50;

/** Minimum query length before the autocomplete fires (mirrors the server guard). */
export const FOOTBALLER_SEARCH_MIN_CHARS = 2;

/** Tile mark from the server comparison. */
export type FootballerMark = 'green' | 'amber' | 'none';

/** The five comparison columns, in display order. */
export const FOOTBALLER_COLUMNS = [
  { key: 'nat', label: 'NAT' },
  { key: 'league', label: 'LGE' },
  { key: 'team', label: 'TEAM' },
  { key: 'pos', label: 'POS' },
  { key: 'age', label: 'AGE' },
] as const;

/** Palette taken directly from the design (values not already in the shared Warmup palette live here). */
export const FOOTBALLER_COLORS = {
  bg: WARMUP_COLORS.bg, // #0F0A1A
  surface: '#1F2937', // cards / header pills
  dropdown: '#1A2030', // autocomplete + empty tiles
  modal: '#111827', // result sheet
  purple: WARMUP_COLORS.purple, // #A78BFA
  yellow: '#FCD34D', // streak flame number
  tileGreen: '#34D399',
  tileGreenText: '#052e16',
  tileEmpty: '#1A2030',
  tileEmptyBorder: 'rgba(255,255,255,0.08)',
  tileNumText: WARMUP_COLORS.text, // #F7FAFC
  tileTextDim: '#9CA3AF',
  arrowUp: '#6EE7B7',
  arrowDown: '#F87171',
  labelFaint: '#4B5563',
  labelDim: '#6B7280',
  hintText: '#D1D5DB',
  inputBg: '#1F2937',
  inputBorder: '#374151',
  inputBorderFocus: '#A78BFA',
  chip: '#374151',
  divider: 'rgba(255,255,255,0.06)',
  mysteryGlowBg: '#170F2E',
  cardBorder: 'rgba(167,139,250,0.12)',
} as const;

export const FOOTBALLER_TEST_IDS = {
  view: 'fq-view',
  board: 'fq-board',
  mysteryCard: 'fq-mystery-card',
  row: 'fq-row',
  searchInput: 'fq-search-input',
  submitButton: 'fq-submit-button',
  dropdown: 'fq-dropdown',
  suggestion: 'fq-suggestion',
  resultOverlay: 'fq-result-overlay',
  shareButton: 'fq-share-button',
  leaderboardButton: 'fq-leaderboard-button',
  nextButton: 'fq-next-button',
} as const;
